import {ColDef} from "ag-grid-community";
export const MenuAdminColumnDefsInit : ColDef[] = [
  {
    headerName: "Label",
    field : "label"
  },
  {
    headerName: "Value",
    field : "value"
  },
  {
    headerName: "Sequence",
    field: "sequence"
  },
  {
    headerName: "URL",
    field : "url"
  },
  {
    headerName: "Types",
    field : "types"
  }
];